<!-- User login window -->
<ng-template #loginModal let-modal>
    <div class="modal-header">
        <!--    <h4 class="modal-title">Anmeldung</h4>-->
        <img src="../../../assets/images/cop4all_90p.png" alt="Cop4ALL Schriftzug">
        <span class="title">Copernicus für ALKIS und Landbedeckung</span>
    </div>
    <div class="modal-body">
      <ng-container *ngIf="!showLoader; else loader">
        <div class="form-group" [ngClass]="{'invisible': showLoader}">
          <label for="labelUser">Benutzername</label>
          <input class="form-control" id="labelUser" type="text" [(ngModel)]=credentials.username>
        </div>
        <div class="form-group" [ngClass]="{'invisible': showLoader}">
          <label for="labelPwd">Passwort</label>
          <input class="form-control" id="labelPwd" type="password" [(ngModel)]=credentials.password>
        </div>
        <div class="form-group form-check" [ngClass]="{'invisible': showLoader}">
          <input type="checkbox" class="form-check-input" id="checkbox-save-login-data" [(ngModel)]="saveData">
          <label class="form-check-label" for="checkbox-save-login-data">
            Anmeldedaten speichern
          </label>
        </div>
        <!-- Message box for the user if something goes wrong-->
        <ngb-alert *ngIf="validLogin.message" [dismissible]="false" type="{{validLogin.type}}">
          {{validLogin.message}}
        </ngb-alert>
      </ng-container>
      <ng-template #loader>
        <!-- Loading bar -->
        <div class="loader-wrapper"><app-loader></app-loader></div>
      </ng-template>
    </div>
    <div class="modal-footer">
        <button class="btn btn-outline-primary" (click)="login()">
            Anmelden
        </button>
    </div>
</ng-template>
